import React from 'react'
import {Grid, TextField, MenuItem} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty, isUndefined} from 'lodash'
import {getKundKontakter} from 'actions'
import IntlMessages from 'util/IntlMessages';

export default function KontaktInput(props) {
  const dispatch = useDispatch()

  const kontakter = useSelector(state => state.accountsData.KontakterList)
  const authUser = useSelector(state => state.auth.authUser)

  const handleChangeKontaktInfo = (key, value) => {
    props.handleChangeKontakt({...props.kontaktObj, [key]: value})
  } 

  React.useEffect(() => {
    if(isUndefined(props.dontGetKontakt)){
   if(!isUndefined(props.OrderKund.Orgnr)) dispatch(getKundKontakter(authUser.user_id,authUser.user_Afid,props.OrderKund.Orgnr))
   }
  },[props.OrderKund])
  console.log(props.kontakt,"JJJPROPS3s")
  console.log(kontakter,"JJJPROPS3s")
  const currencies = [
          {
              value: '1',
              label:<IntlMessages id="Option.Yes"/>,
          },
          {
              value: '0',
              label:<IntlMessages id="Option.No"/>,
          },
      ];
  return (
    <Grid container item spacing={2}>
      <Grid item xs="12">
        <TextField
          label={<IntlMessages id="Contact"/>}
          select
          variant="outlined"
          size="small"
          value={
            isUndefined(props.dontGetKontakt)?
            isEmpty(kontakter) ? 0 : isUndefined(kontakter.find(k => k === props.kontakt)) ? 0 : props.kontakt
            :
            isEmpty(kontakter) ? 0 : isUndefined(kontakter.find(k => k.id === props.kontakt)) ? 0 : props.kontakt
          }
          fullWidth
          name="kontakt"
          // error={kontaktError}
          onChange={(e) => {
            props.handleChange(e)
            // setkontaktError(false)
            console.log(e.target.value)
          }}
        >
          <MenuItem key={0} value={0}>
          <IntlMessages id="appKontoModule.Create.new"/>
          </MenuItem>
          {
          isEmpty(kontakter) ? '' :
          kontakter.map((option) => (
              <MenuItem key={option.id} value={
                isUndefined(props.dontGetKontakt)?option:option.id
                }>
                  {option.fname +" "+option.lname}
              </MenuItem>
          ))
          }
        </TextField>
      </Grid>
      
      {
        parseInt(props.kontakt) === 0 ?
        <>
        <Grid item xs="6">
          <TextField
            label={<IntlMessages id="userProfile.firstName"/>}
            variant="outlined"
            size="small"
            value={props.kontaktObj.FName}
            fullWidth
            // error={ErrorFName}
            onChange={(e) => {
              handleChangeKontaktInfo('FName', e.target.value)
              // setFName(e.target.value)
              // setErrorFName(false)
            }}
            />
        </Grid>
        <Grid item xs="6">
          <TextField
            label={<IntlMessages id="userProfile.lastName"/>}
            variant="outlined"
            size="small"
            value={props.kontaktObj.LName}
            fullWidth
            onChange={(e) => {
              handleChangeKontaktInfo('LName', e.target.value)
              // setLName(e.target.value)
            }}
            />
        </Grid>
        <Grid item xs="6">
          <TextField
            label={<IntlMessages id="userProfile.email"/>}
            variant="outlined"
            size="small"
            value={props.kontaktObj.Email}
            fullWidth
            onChange={(e) => {
              handleChangeKontaktInfo('Email', e.target.value)
              // setEmail(e.target.value)
            }}
            />
        </Grid>
        <Grid item xs="6">
          <TextField
            label={<IntlMessages id="Tele"/>}
            variant="outlined"
            size="small"
            value={props.kontaktObj.Tele}
            fullWidth
            onChange={(e) => {
              handleChangeKontaktInfo('Tele', e.target.value)
              // setTele(e.target.value)
            }}
            />
        </Grid>
        <Grid item xs="6">
          <TextField
            label={<IntlMessages id="userProfile.identityNr"/>}
            variant="outlined"
            size="small"
            value={props.kontaktObj.PersonNr}
            fullWidth
            onChange={(e) => {
              handleChangeKontaktInfo('PersonNr', e.target.value)
              // setTele(e.target.value)
            }}
            />
        </Grid>
        <Grid item xs="6">
          <TextField
            label={<IntlMessages id="Input.signatory"/>}
            variant="outlined"
            size="small"
            value={props.kontaktObj.firmatecknare}
            fullWidth
            select
            SelectProps={{
              native: true,
            }}
            onChange={(e) => {
              handleChangeKontaktInfo('firmatecknare', e.target.value)
              // setTele(e.target.value)
            }}
            >
              {currencies.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
        </Grid>
        </>
        :''
      }
      
    </Grid>
  )
}
